import { render, staticRenderFns } from "./WithMenu.vue?vue&type=template&id=2853b874&"
import script from "./WithMenu.vue?vue&type=script&lang=js&"
export * from "./WithMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports